import type { LabeledStat } from '@/components/common/StatCardGrid';
import { TAKA_SYMBOL } from '@/constants/app.constants';
import type { BudgetTotals, MpSummaryTotals } from '../types/marketPromotion.types';

export function getBudgetStatCards(totals: BudgetTotals | undefined): LabeledStat[] {
  return [
    {
      key: 'budget',
      label: 'Budget',
      value: totals?.budgetAmount,
      unit: TAKA_SYMBOL,
    },
    {
      key: 'disbursed',
      label: 'Disbursed',
      value: totals?.disburseAmount,
      unit: TAKA_SYMBOL,
    },
  ];
}

export function getDistributionSummaryStatCards(
  totals: MpSummaryTotals | undefined,
): LabeledStat[] {
  return [
    ...getBudgetStatCards(totals),
    {
      key: 'distributed',
      label: 'Distributed',
      value: totals?.distributedAmount,
      unit: TAKA_SYMBOL,
    },
    { key: 'approved', label: 'Approved', value: totals?.approvedAmount, unit: TAKA_SYMBOL },
    { key: 'dues', label: 'Dues', value: totals?.duesAmount, unit: TAKA_SYMBOL },
    { key: 'inHand', label: 'In Hand', value: totals?.inHandAmount, unit: TAKA_SYMBOL },
  ];
}
